export default __webpack_public_path__ + "static/media/b2b-works-2.42673348.svg";